import { Icon } from 'ui/components/primitives';
import { Navigation } from './Carousel.components.styles';
import { clickEvents } from 'ui/utilities/helpers/click-events';
import type { ControlProps } from './Carousel.components.d';

const CarouselNavigation = ({ controls, state, gaEvents }: ControlProps) => {
  const { scrollNext, scrollPrev } = controls;
  const { isNextVisible, isPrevVisible, container, desktop, navigationSize } = state;

  return {
    PreviousButton: (
      <Navigation.Wrapper
        data-container={container}
        data-desktop={desktop}
        data-disabled={!isPrevVisible}
        data-testid="button-prev"
        data-size={navigationSize}
        onClick={() => {
          scrollPrev();
          gaEvents && clickEvents('click:anterior', 'interaction_catalogos', 'ciclo-atual');
        }}
      >
        <Navigation.Content
          data-flora="button"
          data-flora-text="anterior"
          data-desktop={desktop}
          data-size={navigationSize}
        >
          <Icon.ArrowLeft size="l" />
          <p>anterior</p>
        </Navigation.Content>
      </Navigation.Wrapper>
    ),
    NextButton: (
      <Navigation.Wrapper
        data-container={container}
        data-desktop={desktop}
        data-disabled={!isNextVisible}
        data-testid="button-next"
        data-size={navigationSize}
        onClick={() => {
          scrollNext();
          gaEvents && clickEvents('click:proximo', 'interaction_catalogos', 'ciclo-atual');
        }}
      >
        <Navigation.Content
          data-flora="button"
          data-flora-text="proximo"
          data-desktop={desktop}
          data-size={navigationSize}
        >
          <p>próximo</p>
          <Icon.ArrowRight size="l" />
        </Navigation.Content>
      </Navigation.Wrapper>
    ),
  };
};

export default CarouselNavigation;
